import { utils } from '@lib/azgaz-ui/connect';
import { isArray } from 'lodash';

import { config } from '@/utils';
import { DEFAULT_GROUP_FILTER, DEFAULT_STATE_FILTER } from '@/constants';

export const getFiltersConfig = () => {
  // const DEFAULT_STATE_FILTER_VALUES = config.get('featureFlagFilteringByStatus')
  //   ? DEFAULT_STATE_FILTER
  //   : ['active'];

  const DEFAULT_GROUP_FILTER_VALUES = config.get('groupFilterEnable')
    ? DEFAULT_GROUP_FILTER
    : ['new'];

  return utils.UiHelper.patchFiltersConfig({
    suzukiHqDisplay: {
      id: 'app_metadata.suzuki_hq_display',
      defaultVal: true,
    },
    model: {
      id: 'model',
      path: 'model',
      defaultVal: config.get('model'),
    },
    engine: {
      id: 'engine',
      path: 'specification.engine',
    },
    transmission: {
      id: 'transmission',
      path: 'specification.transmission',
    },
    drive: {
      id: 'drive',
      path: 'specification.drive',
    },
    grade: {
      id: 'grade',
      path: 'grade',
    },
    color: {
      id: 'color',
      path: 'color',
    },
    city: {
      id: 'city',
      path: 'city',
    },
    group: {
      id: 'group',
      path: 'group',
      defaultVal: DEFAULT_GROUP_FILTER_VALUES,
      prepare: (values: string | string[]) => {
        if (!values || !values.length) return DEFAULT_GROUP_FILTER_VALUES;
        if (!isArray(values)) return [values];
        return values;
      },
    },
    price: {
      id: 'price',
      path: 'price.value.0.0',
      defaultVal: [1, null],
    },
    // state: {
    //   id: 'state',
    //   path: 'state',
    //   defaultVal: DEFAULT_STATE_FILTER_VALUES,
    //   prepare: (values: string | string[]) => {
    //     if (!values || !values.length) return DEFAULT_STATE_FILTER_VALUES;
    //     if (!isArray(values)) return [values];
    //     return values;
    //   },
    // },
    priceTier: {
      id: 'price_tier',
      defaultVal: 0,
    },
    discountTier: {
      id: 'discount_tier',
      defaultVal: 0,
    },
    dealer: {
      id: 'dealer__in',
      path: 'dealer',
      prepare: (dealerId: any) => [dealerId],
    },
    brand: {
      id: 'brand',
      defaultVal: 'suzuki',
    },
    offices: {
      id: 'office_ids',
      path: 'office_ids',
      prepare: (officeId: any) => [officeId],
    },
  });
};

export default getFiltersConfig();
